import React, { useEffect, useState } from "react";
import records from './Product.json';
import { useLocation } from "react-router-dom";
import Footer from "./Footer";


function Sample() {

  let location = useLocation();
  let [filteredData, setFilteredData] = useState(null);

  useEffect(() => {
    let queryParams = new URLSearchParams(location.search);
    console.log(queryParams, 'queryParams');
    let param = queryParams.get('pid')
    console.log(param, 'param');
    if (param) {
      const matchData = records.find(item => item["img-name"] === param);
      setFilteredData(matchData || null);
    }
  }, [location.search])

  {/* {
                records.map(record => {
                    return (
                        <div key={record.id}>
                            <img src={record.image} className="j1-type loop-img"></img>
                            <h3 className="loop-name"> {record["img-name"]}</h3>
                            <i className="fa-solid fa-bars ico"></i>
                            <h3 className="loop-heading">features</h3>
                            <hr className="info-line"></hr>
                            <p className="loop-para"> {record.features[0]} </p>
                            <p className="loop-para"> {record.features[1]} </p>
                            <p className="loop-para"> {record.features[2]} </p>
                            <p className="loop-para"> {record.features[3]} </p>
                            <h3 className="loop-heading">Recommended applications</h3>
                            <hr className="info-line"></hr>
                            <p className="loop-para"> {record.Recommendedapplications[0]} </p>
                            <p className="loop-para"> {record.Recommendedapplications[1]} </p>
                            <p className="loop-para"> {record.Recommendedapplications[2]} </p>
                            <p className="loop-para"> {record.Recommendedapplications[3]} </p>
                            <h3 className="loop-heading">Operating range</h3>
                            <hr className="info-line"></hr>
                            <p className="loop-para">{record.Operatingrange[0]}</p>
                            <p className="loop-para">{record.Operatingrange[1]}</p>
                            <p className="loop-para">{record.Operatingrange[2]}</p>
                            <p className="loop-para">{record.Operatingrange[3]}</p>
                            <h3 className="loop-heading">Combination material</h3>
                            <hr className="info-line"></hr>
                            <p className="loop-para">{record.Combinationmaterial[0]}</p>
                            <p className="loop-para">{record.Combinationmaterial[1]}</p>
                            <p className="loop-para">{record.Combinationmaterial[2]}</p>
                            <p className="loop-para">{record.Combinationmaterial[3]}</p>
                        </div>
                    )
                })
            } */}

  return (
    <>
    <div>
      {filteredData ? (
        <div>
          {/* <h2>{filteredData['img-name']}</h2>
                      <img src={filteredImage.src} alt={filteredImage.alt} /> */}
          <div key={filteredData.id} className="detail-data">
            <img src={filteredData.image} className="j1-type loop-img"></img>
            <h3 className="loop-name"> {filteredData["img-name"]}</h3>
            {/* <i className="fa-solid fa-bars ico bar-f"></i> */}
            <h3 className="loop-heading">features</h3>
            <hr className="info-line"></hr>
            {filteredData.features?.map((feature, index) => (
            <li key={index} className="loop-para"> {feature} </li>
          ))}
            {/* <span className="dot"></span> */}
            {/* <p className="loop-para">  &#9679; {filteredData.features[0]} </p> */}
            {/* <span className="dot"></span> */}
            {/* <p className="loop-para">  &#9679; {filteredData.features[1]} </p>
            <p className="loop-para">  &#9679; {filteredData.features[2]} </p>
            <p className="loop-para">  &#9679; {filteredData.features[3]} </p> */}
            {/* <i className="fa-solid fa-bars ico bar-r"></i> */}
            
            <h3 className="loop-heading">Recommended applications</h3>
            <hr className="info-line"></hr>
            {filteredData.Recommendedapplications?.map((item, index) => (
            <li key={index} className="loop-para"> {item} </li>
          ))}
            {/* <p className="loop-para">  &#9679; {filteredData.Recommendedapplications[0]} </p>
            <p className="loop-para">  &#9679; {filteredData.Recommendedapplications[1]} </p>
            <p className="loop-para">  &#9679; {filteredData.Recommendedapplications[2]} </p>
            <p className="loop-para">  &#9679; {filteredData.Recommendedapplications[3]} </p>
            <i className="fa-solid fa-bars ico bar-0"></i> */}
            <h3 className="loop-heading">Operating range</h3>
            <hr className="info-line"></hr>
            {filteredData.Operatingrange?.map((range, index) => (
            <li key={index} className="loop-para"> {range} </li>
          ))}
            {/* <p className="loop-para">  &#9679; {filteredData.Operatingrange[0]}</p>
            <p className="loop-para"> &#9679; {filteredData.Operatingrange[1]}</p>
            <p className="loop-para">  &#9679; {filteredData.Operatingrange[2]}</p>
            <p className="loop-para">  &#9679; {filteredData.Operatingrange[3]}</p> */}
            {/* <i className="fa-solid fa-bars ico bar-c"></i> */}
            <h3 className="loop-heading">Combination material</h3>
            <hr className="info-line"></hr>
            {filteredData.Combinationmaterial?.map((material, index) => (
            <li key={index} className="loop-para">{material} </li>
          ))}
            {/* <p className="loop-para">  &#9679; {filteredData.Combinationmaterial[0]}</p>
            <p className="loop-para">  &#9679; {filteredData.Combinationmaterial[1]}</p>
            <p className="loop-para"> &#9679; {filteredData.Combinationmaterial[2]}</p>
            <p className="loop-para">&#9679; {filteredData.Combinationmaterial[3]}</p> */}
            <img src={filteredData["img-info"]} className="imgdatainfo"></img>
          </div>
        </div>

      ) : (
        <p className="ndf">No matching data found.</p>
      )}
    </div>

    <Footer></Footer>
    </>
  );
};

export default Sample